<template>
  <div>
    <UserCreate/>
  </div>
</template>

<script>
import  UserCreate  from '@/components/backend/user/UserCreate.vue'

export default {
  name: 'UserCreateView',
  components: {
    UserCreate
  },
  data: () => {
    return {
    }
  },
  methods: {
  }
}
</script>

<style scoped>
</style>
